import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  newMeetingInfo: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
  },
  titleText: {
    color: theme.palette.facet.primaryGray,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 16,
    textAlign: 'center',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  infoText: {
    color: theme.palette.facet.primaryBlue,
    fontSize: 18,
    textAlign: 'center',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  attendeesContainer: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
  },
  descriptionContainer: {},
  descriptionLabel: {
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.8rem',
  },
  descriptionTextarea: {
    height: 100,
  },
});

const MeetingBookedLayout = ({
  className,
  classes,
}) => {
  const { resource: calendarEventResource } = useMetaLayoutContext();
  const tz = moment.tz.guess();

  const meetingTitle = calendarEventResource.attr('title');
  const agentZoomUrl = calendarEventResource.attr('location')?.replace('https://', '');
  const calendarEventStart = moment(calendarEventResource.attr('startTime')).tz(tz);
  const dateTitle = calendarEventStart.format('dddd MMMM Do');
  const timeTitle = calendarEventStart.format('h:mmA z');

  return (
    <div className={classNames(classes.root, className)}>
      <Typography variant="h3" className={classes.titleText}>
        {meetingTitle}
      </Typography>
      <div className={classes.newMeetingInfo}>
        <Typography variant="h3" className={classes.infoText} test="new-meeting-date-header">
          <b>Date:</b> {dateTitle}
        </Typography>
        <Typography variant="h3" className={classes.infoText}>
          <b>Time:</b> {timeTitle}
        </Typography>
        <Typography variant="h3" className={classes.infoText}>
          <b>Zoom:</b> {agentZoomUrl}
        </Typography>
      </div>
      <div className={classes.attendeesContainer}>
        <MetaControlField attr="attendees" />
      </div>
    </div>
  );
};

MeetingBookedLayout.defaultProps = {
  className: '',
};

MeetingBookedLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MeetingBookedLayout);
